import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login.vue'),
    },
    {
        path: '/form',
        name: 'Form',
        component: () => import('@/views/Form.vue'),
    },
    {
        path: '/news',
        name: 'News',
        component: () => import('@/views/levelA/News.vue'),
        meta: {
            group: '媒體訊息',
            title: '新聞資訊',
            icon: 'mdi-newspaper',
        },
    },
    {
        path: '/news/category',
        name: 'Category',
        component: () => import('@/views/levelA/NewsCategory.vue'),
        meta: {
            group: '媒體訊息',
            title: '新聞類別',
            icon: 'mdi-shape',
        },
    },
    {
        path: '/event',
        name: 'Event',
        component: () => import('@/views/levelA/Event.vue'),
        meta: {
            group: '媒體訊息',
            title: '影像集錦',
            icon: 'mdi-calendar-range-outline',
        },
    },
    {
        path: '/announcement',
        name: 'Announcement',
        component: () => import('@/views/levelA/Announcement.vue'),
        meta: {
            group: '投資關係',
            title: '重大公告',
            icon: 'mdi-chart-tree',
        },
    },
    {
        path: '/report/finance',
        name: 'FinanceReport',
        component: () => import('@/views/levelA/Report.vue'),
        meta: {
            group: '投資關係',
            title: '財務公告',
            icon: 'mdi-finance',
        },
    },
    {
        path: '/manager',
        name: 'Manager',
        component: () => import('@/views/levelA/Manager.vue'),
        meta: {
            role: 'admin',
            group: '人員管理',
            title: 'B級權限管理',
            icon: 'mdi-account',
        },
    },
    {
        path: '/password/update',
        name: 'UpdatePassword',
        component: () => import('@/views/Password.vue'),
        meta: {
            title: '修改密碼',
            icon: 'mdi-lock-reset',
        },
    },
    { path: '*', redirect: { name: 'Login' } },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return { x: 0, y: 0 };
    },
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => !record.redirect && record.name !== 'Login')) {
        if (!store.getters['auth/isLoggedIn']) {
            store.dispatch('auth/tryAutoLogin').then((success) => {
                if (success) next();
                else next({ name: 'Login' });
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
